import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"

export default function ImageGalleryView({
    thumbView,
    detailView,
    current,
    children,
    enlarged,
    labels,
    onToggleEnlarge,
    onSelect,
    onPrev,
    onNext,
}) {
    const ThumbView = ComponentRegistry.get(thumbView);
    const DetailView = ComponentRegistry.get(detailView);

    const controls = [];
    controls.push(
      <a
        key="toggle-enlarge"
        href={`#${enlarged ? "shrink" : "enlarge"}`}
        className={`icon icon-${enlarged ? "close" : "open"}`}
        onClick={onToggleEnlarge}
      >{ enlarged ? labels.close : labels.open }</a>,
    );

    const thumbnails = Object.values(children).map(
        (child, index) => <ThumbView key={index} {...child} onSelect={() => onSelect(index)} />,
    );

    if (thumbnails.length > 1) {
        controls.push(
          <a key="next" href="#next" className="icon icon-next" onClick={onNext}>{labels.next}</a>,
        );
        controls.push(
          <a key="prev" href="#prev" className="icon icon-prev" onClick={onPrev}>{labels.previous}</a>,
        );
    }

    return (
      <section className={`${enlarged ? "open " : ""}gallery clearfix`}>
        <DetailView {...current} onToggleEnlarge={onToggleEnlarge} />

        {thumbnails.length > 1 ?
          <ul className="gallery-items clearfix">
            {thumbnails}
          </ul> : null}

        {controls}
      </section>
    );
}

ImageGalleryView.propTypes = {
    detailView: PropTypes.string.isRequired,
    thumbView: PropTypes.string.isRequired,
    current: PropTypes.shape({}),
    children: PropTypes.arrayOf(PropTypes.shape({})),
    enlarged: PropTypes.bool.isRequired,
    labels: PropTypes.shape({
        open: PropTypes.string,
        close: PropTypes.string,
        previous: PropTypes.string,
        next: PropTypes.string,
    }),
    onToggleEnlarge: PropTypes.func,
    onSelect: PropTypes.func,
    onPrev: PropTypes.func,
    onNext: PropTypes.func,
};

ImageGalleryView.defaultProps = {
    detailView: "ImageGalleryViewsDetailView",
    thumbView: "ImageGalleryViewsThumbView",
};




// WEBPACK FOOTER //
// ./src-js/Fratello/ImageGallery/Views/ImageGalleryView.jsx